import React from "react";
import { IAboutDescriptionData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import { marked } from "marked";

const AboutDescription = (props: {
  aboutDescriptionData: IAboutDescriptionData[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  return (
    <section className="about-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div style={{ width: "100%", position: "relative" }}>
              <div
                className="about-page__img-wrapper"
                style={{
                  float: !mobile && !tab ? "left" : "unset",
                  width: !mobile && !tab ? "45%" : "100%",
                  marginRight: !mobile && !tab ? "50px" : "unset",
                  marginBottom: "1rem",
                }}
              >
                <Fade
                  cascade
                  damping={0.2}
                  delay={1200}
                  direction="left"
                  triggerOnce={true}
                >
                  <div className="about-page__img">
                    <img
                      src={
                        props?.aboutDescriptionData[0]?.image[0]?.media?.url &&
                        `${process.env.REACT_APP_cmsUrl}${props?.aboutDescriptionData[0]?.image?.[0]?.media?.url}`
                      }
                      alt="about-image"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "498px",
                      }}
                    />
                  </div>
                </Fade>
              </div>

              <div className="about-page__right">
                <div className="section-title text-left">
                  <span className="custom-fontweight">
                    {props?.aboutDescriptionData[0]?.primary_title}
                  </span>
                  <h2 className="section-title__title">
                    {props?.aboutDescriptionData[0]?.secondary_title}
                  </h2>
                </div>
                <p
                  className="about-page__text"
                  style={{ textAlign: "justify" }}
                  dangerouslySetInnerHTML={{
                    __html: marked(
                      props?.aboutDescriptionData[0]?.description || "",
                    ) as string,
                  }}
                ></p>
              </div>

              {/* Optional: Clear floated image */}
              {/* <div style={{ clear: "both" }}></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutDescription;
